"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutePlanScheduleUpdate = exports.RoutePlanScheduleCreate = exports.RoutePlanScheduleQuery = exports.RoutePlanScheduleTransport = exports.RoutePlanSchedule = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
exports.RoutePlanSchedule = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    driverID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    ordinal: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    date: typebox_1.Type.String({ format: 'date' }),
    vehicleID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    rescheduledFromDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    metadata: common_1.MetaData,
});
exports.RoutePlanScheduleTransport = exports.RoutePlanSchedule;
exports.RoutePlanScheduleQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        driverID: typebox_1.Type.String({ format: 'uuid' }),
        date: typebox_1.Type.String({ format: 'date' }),
        vehicleID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.RoutePlanScheduleCreate = typebox_1.Type.Omit(exports.RoutePlanSchedule, ['id', 'haulerID', 'metadata']);
exports.RoutePlanScheduleUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanSchedule, ['id', 'haulerID', 'driverID', 'metadata']),
    typebox_1.Type.Object({ driverID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })) }),
]));
//# sourceMappingURL=RoutePlanSchedule.js.map